module.exports = __webpack_public_path__ + "public/images/stands-logo-1@2x.664043da34e9362c87e3d0c3cb95da39.webp";